import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Company name (from data) | "Domicile" for an order's delivery choice; null when the order has none. */
export const deliveryCompanyLabel = (t, { deliveryMethod, deliveryCompany, deliveryCompanyName }) => {
  if (deliveryCompany) return deliveryCompanyName || deliveryCompany;
  if (deliveryMethod === 'HOME') return t('delivery.home');
  return null;
};

/** Full sentence for details pages: "Alger — Livraison point relais — Expédier avec : Zr". */
export const deliverySummary = (t, order) => {
  if (!order?.deliveryMethod) return null;
  const parts = [];
  if (order.deliveryWilayaName) parts.push(order.deliveryWilayaName);
  parts.push(order.deliveryMethod === 'HOME' ? t('delivery.homeFull') : t('delivery.pickupFull'));
  if (order.deliveryCompany) {
    parts.push(t('delivery.shipWith', { company: order.deliveryCompanyName || order.deliveryCompany }));
  }
  return parts.join(' — ');
};

/**
 * Small chip so the admin sees at a glance who ships the order (the delivery company) or that it is a home
 * delivery. Renders nothing for orders without a delivery choice (staff orders, older orders).
 */
const DeliveryChip = ({ order }) => {
  const { t } = useTranslation();
  const label = deliveryCompanyLabel(t, order || {});
  if (!label) return null;
  return (
    <Tooltip title={deliverySummary(t, order)}>
      <Chip
        label={label}
        size="small"
        variant="outlined"
        color={order.deliveryMethod === 'HOME' ? 'secondary' : 'primary'}
      />
    </Tooltip>
  );
};

export default DeliveryChip;
